import { Component, OnInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import {NgbDropdownConfig, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../core/authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { AccountRoles, CarrierType } from '../../shared/constants/account-roles.enum';
import { CommonApi } from '../../core/http/common.api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HeaderService } from './header.service';
import { HeaderMenuState } from './header-menu.state';
import { Subscription } from 'rxjs';
import { LanguageConstant } from '../../../app/shared/constants/language-constant';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  providers: [NgbDropdownConfig]
//   styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  languages = LanguageConstant.GetAllAsDataItem();
  user: any;
  selectedLangName: any;
  accountRoles = AccountRoles;
  carrierType = CarrierType;
  notifications: Notification[];
  notificationCount: number;
  companyLogo: string;
  listActive: boolean;
  dealActive: boolean;
  shipperListActive: boolean;
  carrierListActive: boolean;
  settlementListActive: boolean;
  dealsToSettleActive: boolean;
  settledDealsActive: boolean;
  paymentAdviceActive: boolean;
  freightPostMenuActive: boolean;
  freightPostsActive: boolean;
  freightPostSearchActive: boolean;
  freightPostRequestsActive: boolean;
  freightPostRequestListActive:boolean;
  private menuStateSubscription: Subscription;
  @ViewChild('contentAlertCreateRequest') contentAlertCreateRequestRef: TemplateRef<any>;
  constructor(
    config: NgbDropdownConfig,
    private translate: TranslateService,
    private authService: AuthenticationService,
    private commonApi: CommonApi,
    private router: Router,
    private headerService: HeaderService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {
    config.placement = 'bottom-right';
    this.authService.getIsAuthorized().subscribe(isAuthorized => {
      if (isAuthorized) {
        this.commonApi.getCurrentUser().subscribe(data => {
          this.user = data;
          this.user.role = this.user.role.toLocaleLowerCase();
          this.commonApi.getUserNotifications().subscribe(notis => {
            this.notifications = notis;
          });

          this.commonApi.getCompanyLogo(this.user.userId).subscribe((resp: any) => {
            this.companyLogo = resp.base64 ? 'data:image/jpg;base64,' + resp.base64 : "";
          });

          this.commonApi.countUnreadUserNotification().subscribe(count => {
            this.notificationCount = count;
          });

          this.commonApi.getUserSetting().subscribe((data: any) => {
            localStorage.setItem('verified_business_registration', data.verifiedBusinessRegistration);
            localStorage.setItem('is_lockout_enabled', data.isLockoutEnabled);
            this.selectedLangName = this.languages.find(x => x.value === data.language).display;
            this.translate.use(data.language);
          });
        });
      }
    });
  }

  ngOnInit() {
    this.menuStateSubscription = this.headerService.headerMenuState.subscribe((menuState: HeaderMenuState) => {
      this.listActive = menuState.listActive || false;
      this.dealActive = menuState.dealActive || false;
      this.shipperListActive = menuState.shipperListActive || false;
      this.carrierListActive = menuState.carrierListActive || false;
      this.settlementListActive = menuState.settlementListActive || false;
      this.dealsToSettleActive = menuState.dealsToSettleActive || false;
      this.settledDealsActive = menuState.settledDealsActive || false;
      this.paymentAdviceActive = menuState.paymentAdviceActive || false;
      this.freightPostsActive = menuState.freightPostsActive || false;
      this.freightPostSearchActive = menuState.freightPostSearchActive || false;
      this.freightPostMenuActive = menuState.freightPostsActive || menuState.freightPostRequestListActive || menuState.freightPostSearchActive;
      this.freightPostRequestListActive = menuState.freightPostRequestListActive || false;
    });
  }

  ngOnDestroy() {
    this.menuStateSubscription.unsubscribe();
  }

  onLanguageChange(selectedLang) {
    if (selectedLang) {
      this.selectedLangName = this.languages.find(x => x.value === selectedLang).display;
      this.translate.use(selectedLang);
      localStorage.setItem('language', selectedLang);
    }
  }

  onClickChangePassword() {
    // tslint:disable-next-line:max-line-length
    window.location.href = environment.aadConfig.stsServer + 'authorize?p=' + environment.aadConfig.password_change_policy + '&client_id=' + environment.aadConfig.client_id + '&nonce=defaultNonce&redirect_uri=' + environment.aadConfig.redirect_url + '&scope=openid&response_type=id_token&prompt=login';
  }

  onClickSignOut() {
    //this.authService.logout();
    this.logoutAll();
  }

  onBellClick() {
    if (this.notificationCount > 0) {
      this.commonApi.updateAllNotificaionAsRead().subscribe(() => {
        this.notificationCount = 0;
      });
    }
    else {
      this.notifications.forEach((item:any) => {
        item.read = true;
      })
    }
  }

  onNotificationClick(requestId: number) {
    this.router.navigate([`request/profile/${requestId}`]);
  }

  goDashboardHangfire() {
    let keyToken = 'authorizationData_';
    let values = Object.keys(localStorage)
                   .filter((key)=> key.startsWith(keyToken))
                   .map((key)=> localStorage[key]);
    var token = (values[0] as string).replace(/["']/g, "");
    var ifrm = document.createElement("iframe");
        ifrm.setAttribute("src", `${environment.apiBaseUrl}/efcl-hangfire?token=${token}`);
        ifrm.style.width = "100px";
        ifrm.style.height = "100px";
        ifrm.style.display = "none";
        ifrm.onload = () => {
          window.location.href = `${environment.apiBaseUrl}/efcl-hangfire`;
        }
        document.body.appendChild(ifrm);
  }

  logoutAll() {
    if(this.user.role.toLocaleLowerCase() == this.accountRoles.CustomerService) {
      var ifrm = document.createElement("iframe");
      ifrm.setAttribute("src", `${environment.apiBaseUrl}/efcl-hangfire?logout=true`);
      ifrm.style.width = "100px";
      ifrm.style.height = "100px";
      ifrm.style.display = "none";
      ifrm.onload = () => {
        this.authService.logout();
      }
      document.body.appendChild(ifrm);
    } else {
      this.authService.logout();
    }
  }

  goCreateRequest() {
    let isVerified = localStorage.getItem('verified_business_registration');
    if(isVerified != null && isVerified.toLowerCase() == 'true') {
      this.router.navigate(['request/create']);
    } else {
      this.modalService.open(this.contentAlertCreateRequestRef, { centered: true, windowClass: 'cancel-modal' })
    }
  }

  isSettlementActive() {
    return (this.settlementListActive
      || this.dealsToSettleActive
      ||  this.settledDealsActive
      || this.paymentAdviceActive);
  }
}
